import type { RiskClass } from '@ralph/contracts'
import type { Messages } from '@/i18n/index.ts'

/**
 * The one lookup the approval card makes into its catalogue, kept out of the catalogue
 * (PRD-27 D-25, LOC-017).
 *
 * `PendingApproval.risk` is `string`, not `RiskClass` — `run-stream-reducer.ts` widens it on
 * the way in — so the card has to look the value up rather than index it. Written here
 * rather than beside the words so that no locale can acquire its own fallback behaviour: a
 * pt-BR catalogue is a list of words, never a list of decisions.
 */
export const riskLabel = (t: Messages['approvals'], risk: string): string =>
  risk in t.risk ? t.risk[risk as RiskClass] : t.riskUnknown
